import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { FileText, Shield, Scale } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../context/SiteSettingsContext';

const ConfidentialitePage = () => {
  const { settings } = useSiteSettings();
  const legalSettings = settings.legal?.confidentialite || {};
  const sections = legalSettings.sections || [];

  const renderContent = (content) => {
    if (!content) return null;
    return content.split('\n').map((line, i) => {
      const parts = line.split(/(\*\*.*?\*\*)/g);
      return (
        <p key={i} className="text-gray-600 mb-1">
          {parts.map((part, j) => {
            if (part.startsWith('**') && part.endsWith('**')) {
              return <strong key={j}>{part.slice(2, -2)}</strong>;
            }
            if (part.startsWith('•')) {
              return <span key={j} className="block ml-4">{part}</span>;
            }
            return part;
          })}
        </p>
      );
    });
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      
      <main className="flex-grow py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Navigation */}
          <div className="flex flex-wrap gap-4 mb-8">
            <Link 
              to="/mentions-legales" 
              className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-600 rounded-lg font-medium hover:bg-gray-200 transition-colors"
            >
              <Scale className="w-4 h-4" /> Mentions légales
            </Link>
            <Link 
              to="/cgu" 
              className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-600 rounded-lg font-medium hover:bg-gray-200 transition-colors"
            >
              <FileText className="w-4 h-4" /> CGU
            </Link>
            <Link 
              to="/confidentialite" 
              className="flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-lg font-medium"
            >
              <Shield className="w-4 h-4" /> Confidentialité
            </Link>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-8">
            {legalSettings.title || 'Politique de Confidentialité'}
          </h1>
          
          <div className="prose prose-lg max-w-none">
            {sections.map((section, index) => (
              <section key={section.id || index} className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">{section.title}</h2>
                {renderContent(section.content)}
              </section>
            ))}

            <p className="text-sm text-gray-400 mt-8">
              Dernière mise à jour : {legalSettings.lastUpdate || 'Janvier 2025'}
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ConfidentialitePage;
